export default __webpack_public_path__ + "static/6-d22740090e849b4e09179cbbf4957f16.jpg";